import { render, staticRenderFns } from "./PersonalPwdEditLayer.vue?vue&type=template&id=1a94d51c&scoped=true&"
import script from "./PersonalPwdEditLayer.vue?vue&type=script&lang=js&"
export * from "./PersonalPwdEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPwdEditLayer.vue?vue&type=style&index=0&id=1a94d51c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94d51c",
  null
  
)

export default component.exports